module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURTVp4zdn3zRq4zVq4zRp4jVq4TVp40dwTDVq4zVp4jRq4zNr4zZp4jRp4i9v3zVq4jVp4zVq5DVp4jRq4jVq43gXk0YAAAAUdFJOU4Ag3/A/YLAAwL+vQFDQEJDvMOCgH41BAwAAAIBJREFUOMu9k8sOwyAMBBdSwDSvNtn//9YAOfRkN1Ja5mIJzcGs1khfQBdhfOhUIdLgmRBIUSEDQNEXEOKKYNJJuP+LK8LMHfSL8wyxxOv8a6rzIwhXcFvcUIU5lTnJ+f6zHdbceKvCcKYS/piDJZTKZZVauWIZxFZ7qIy9Ts/mAJvRJjh9dhrzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/yikatong.jpg
// module id = oui8
// module chunks = 1